import { formatDateTime, formatDecimalUnit } from '@/common/utils/formatters'
import UpdateLastUsageDeclarationsPerCategory from '../components/show/lastUsageDeclarationsPerCategory/updateLastUsageDeclarationsPerCategory'
import { EquipmentData } from '../types/equipments.type'

export class EquipmentLastUsageDeclarationsPerCategoryTransformer {
  static tableTransformer(equipment?: EquipmentData) {
    return (usageDeclarations: any[]) => {
      return usageDeclarations.map((usageDeclaration) => {
        return {
          transaction_id: usageDeclaration.transaction_id,
          product_category: usageDeclaration.resolved_category_name,
          created_at: usageDeclaration.created_at
            ? formatDateTime(new Date(usageDeclaration.created_at))
            : '',
          value: usageDeclaration?.value
            ? formatDecimalUnit(usageDeclaration.value, equipment?.model?.category.unit_for_consumption)
            : '',
          author: usageDeclaration.author,
          actions: (
            <div className='flex items-center justify-center gap-3'>
              {equipment && (
                <UpdateLastUsageDeclarationsPerCategory
                  equipment={equipment}
                  categoryId={usageDeclaration.resolved_category_id}
                  categoryName={usageDeclaration.resolved_category_name}
                  value={usageDeclaration.value}
                />
              )}
            </div>
          ),
        }
      })
    }
  }
}
